
import { Component } from 'vue-property-decorator';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase';
import PageRequest from '@/store/entities/page-request';
import ListView from '@/components/helper/list-view.vue';
import Ajax from '@/lib/ajax';
import SaleForm from './sale-form.vue';
import ImportChanges from './import-changes.vue';
import DealerList from './dealer-list.vue';
import CemMultiFilter from './multi-filter.vue';

class PageSaleRequest extends PageRequest {
    year: any = parseInt(Util.abp.clock.today().substr(0, 4));
    month: any = parseInt(Util.abp.clock.today().substr(5, 2));
    dealer: number = null;
    manufacturer: number = null;
    process_type: number = null;
    vin: string = null;
    dealer_ids: number[] = [];
    manufacturer_ids: number[] = [];
    //type: number = null;
}

@Component({
    components: { ListView, SaleForm, ImportChanges, DealerList, CemMultiFilter }
})
export default class Sales extends ListBase {
    entity: string = 'sale';
    pagerequest: PageSaleRequest = new PageSaleRequest();
    filterForm: boolean = true;
    selProcess: number = Util.abp.list.get('PROCESS', 'PV').id;
    //selProcess: number = this.processList[0].id;
    showImport: boolean = false;
    showDealers: boolean = false;
    widType: string = 'Postventa';
    exporting: boolean = false;
    filterTimer: any = null;

    columns = [
        this.gCol('number', 'Nro', 'text', '', false),
        this.gCol('dealer.name', 'Concesionario', 'text', '', false),
        this.gCol('manufacturer.name', 'Marca', 'text', '', false),
        this.gCol('plate', 'Placa', 'text', '', false),
        this.gCol('vin', 'Chasis', 'text', '', false),
        this.gCol('model', 'Modelo', 'text', '150px', false),
        this.gCol('city', 'Ciudad', 'text', '', false),
        this.gCol('ot', 'OT', 'text', '', false),
        this.gCol('km', 'Ultimo kilometraje', 'text', '', false),
        this.gCol('customer', 'Nombre de Cliente', 'text', '250px', false),
        this.gCol('document', 'DNI', 'text', '', false),
        this.gCol('cellphone', 'Telefono', 'text', '130px', false),
        this.gCol('email', 'Email', 'text', '', false),
        this.gCol('service_date', 'Fecha de Servcio', 'date', '', false),
        this.gCol('year', 'Anio', 'text', '', false),
        this.gCol('month', 'Mes', 'text', '', false),
        this.gCol('assessor_name', 'Asesor', 'text', '200px', false),
        this.gCol('technician_name', 'Tecnico', 'text', '200px', false),
        this.gColO({ type: 'text', value: 'service_type_id', text: 'Tipo de Trabajo', generalType: true, sortable: false }),
        this.gColO({ type: 'text', value: 'payer_id', text: 'Pagador', generalType: true, sortable: false }),
        this.gCol('total', 'Facturacion', 'text', '', false),
        this.defaultActions('view', 80)
    ]

    //get processList() {
    //    return Util.abp.list.getList('PROCESS');
    //}
    get process() {
        return Util.abp.list.getItem(this.selProcess);
    }
    get periods() { return this.gCommonList('years'); }
    get months() { return this.gCommonList('months'); }
    get dealers() {
        return this.$store.state.dealer.activeList.map((item: any) => ({
            ...item,
            display_name: `${item.name}${item.location ? ' - ' + item.location : ''}`,
        }));
    }
    get manufacturers() { return this.$store.state.manufacturer.activeList; }
    get checking() {
        return this.$store.state.dashboard.loading;
    }
    get loading() {
        return this.$store.state.sale.loading;
    }
    get widgets() {
        let sales = this.$store.state.dashboard.sales;
        let day = Util.abp.setting.get('CEM_ALERT_DAY');
        let day_weeks = this.gCommonList('week_days');
        return [
            //{ value: (sales[0] != undefined ? sales[0] : '0'), name: 'Venta', icon: 'point_of_sale', desc: 'Nro Importaciones', onclick: this.openDealer },
            { value: (sales[1] != undefined ? sales[1] : '0'), name: 'Postventa', icon: 'home_repair_service', desc: 'Nro Importaciones', onclick: this.openDealer },
            { value: (sales[2] != undefined ? sales[2] : '0'), name: 'Pendientes', icon: 'pending', desc: 'Postventa', onclick: this.openDealer },
            { value: (sales[3] != undefined ? sales[3] : 'Fecha'), name: 'Plazo', icon: 'schedule', desc: 'Plazo de Entrega - ' + day_weeks[day - 1].name, onclick: null },
        ];
    }
    get isDealer() {
        return Util.abp.session.isDealer();
    }

    view() {
        this.modalShow = !this.modalShow;
    }
    create() {
        this.modalShow = !this.modalShow;
    }

    openDealer(item) {
        this.widType = item.name;
        this.showDealers = true;
    }

    async changeYear() {
        this.filterChanged();
        await this.loadData();
    }

    async changeMonth() {
        this.filterChanged();
        await this.loadData();
    }

    filterChanged() {
        clearTimeout(this.filterTimer);
        this.filterTimer = setTimeout(() => this.applyPendingFilters(), 150);
    }

    async applyPendingFilters() {
        if (this.loading) {
            this.filterTimer = setTimeout(() => this.applyPendingFilters(), 200);
            return;
        }
        await this.getpage();
    }

    async getpage() {
        this.$store.commit('sale/setProcess', this.selProcess);
        let list: any = this.$refs.listView
        if (list != undefined) {
            this.pagerequest.process_type = this.selProcess;
            await list.getpage();
        }
    }

    async exportData() {
        this.exporting = true;
        try {
            const response = await Ajax.get('/api/sales-export', { params: this.pagerequest, responseType: 'blob' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(response.data);
            link.download = 'CEM_Postventa.xlsx';
            link.click();
            URL.revokeObjectURL(link.href);
        } finally { this.exporting = false; }
    }
    async loadData() {
        await this.$store.dispatch({
            type: 'dashboard/getWidgetSales',
            data: {
                year: this.pagerequest.year,
                month: this.pagerequest.month
            }
        });
    }

    async processApiSales() {
        await this.$store.dispatch({
            type: 'sale/processApiSales',
            data: {
                year: this.pagerequest.year,
                month: this.pagerequest.month
            }
        });
        await this.getpage();
        await this.loadData();
    }

    async mounted() {
        this.$store.commit('sale/setProcess', this.selProcess);
        await Promise.all([
            this.$store.dispatch({ type: 'dealer/getAllActive' }),
            this.$store.dispatch({ type: 'manufacturer/getAllActive' }),
        ]);
        await this.loadData();
    }

    created() {
        this.pagerequest.process_type = this.selProcess;
    }
}
